import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  borrower1_is_veteran: Yup.boolean().nullable(),
  borrower2_is_veteran: Yup.boolean().nullable(),
  borrower1_use_va_entitlement: Yup.boolean().nullable(),
  borrower2_use_va_entitlement: Yup.boolean().nullable(),
  is_va_loan_application_borrower_value: Yup.boolean().required(),
});

export const initialValues = {
  borrower1_is_veteran: null,
  borrower2_is_veteran: null,
  borrower1_use_va_entitlement: null,
  borrower2_use_va_entitlement: null,
  is_va_loan_application_borrower_value: false,
};
